import getValidationErrorMessages from "./getValidationErrorMessages";
export default function getValidationErrorMessage(e) {
    return getValidationErrorMessages(e)
        .join('; ');
}
//# sourceMappingURL=getValidationErrorMessage.js.map